export default __webpack_public_path__ + "static/media/11.629cd8aa.mp3";